import ReportIcon from '@mui/icons-material/Flag';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import FlatButton from 'components/FlatButton';

const ReportButton = ({ flagged, ...props }) => (
  <FlatButton
    {...props}
    icon={useMemo(
      () => (
        <ReportIcon
          htmlColor={flagged
            ? '#FF495F'
            : null}
        />
      ),
      [flagged],
    )}
    label={useMemo(
      () => (flagged
          ? 'Reported'
          : 'Report'
      ),
      [flagged],
    )}
    labelStyle={useMemo(
      () => (flagged
          ? { color: '#FF495F' }
          : null),
      [flagged],
    )}
  />
);

ReportButton.propTypes = {
  ...FlatButton.propTypes,
  flagged: PropTypes.bool.isRequired,
};

export default ReportButton;
